import { useEffect, useState } from "react";
import { Plus, Trash2, X, Users } from "lucide-react";
import { useRag } from "../RagContext";
import BandoMembersModal from "./BandoMembersModal";
import "./BandoSelector.css";

export default function BandoSelector() {
    const {
        bandi,
        currentBandoId,
        loading,
        selectBando,
        createBando,
        deleteBando,
        loadMembers,
        canManageMembers,
    } = useRag();
    const [showCreate, setShowCreate] = useState(false);
    const [newName, setNewName] = useState("");
    const [creating, setCreating] = useState(false);
    const [showMembers, setShowMembers] = useState(false);

    const currentBando = bandi.find((b) => b.id === currentBandoId);

    // Carica i membri ogni volta che cambia il bando: serve sia per UX gating
    // dei pulsanti delete documenti / delete bando, sia per pre-popolare il modal.
    useEffect(() => {
        if (currentBandoId) {
            loadMembers(currentBandoId);
        }
    }, [currentBandoId, loadMembers]);

    const handleSelect = (e) => {
        const value = e.target.value;
        selectBando(value || null);
    };

    const handleCreate = async (e) => {
        e.preventDefault();
        if (!newName.trim()) return;
        setCreating(true);
        try {
            const bando = await createBando(newName.trim());
            setNewName("");
            setShowCreate(false);
            if (bando?.id) selectBando(bando.id);
        } catch {
            // gestito a livello reducer/error
        } finally {
            setCreating(false);
        }
    };

    return (
        <div className="rag-bando-selector">
            <label className="rag-bando-selector__label">Bando</label>
            <div className="rag-bando-selector__row">
                <select
                    className="rag-bando-selector__select"
                    value={currentBandoId || ""}
                    onChange={handleSelect}
                    disabled={loading.bandi || showCreate}
                >
                    <option value="">— Seleziona bando —</option>
                    {bandi.map((b) => (
                        <option key={b.id} value={b.id}>
                            {b.name}
                        </option>
                    ))}
                </select>

                {!showCreate ? (
                    <>
                        {currentBando && (
                            <button
                                type="button"
                                className="rag-bando-selector__btn"
                                onClick={() => setShowMembers(true)}
                                aria-label="Gestisci membri"
                                title="Gestisci membri"
                            >
                                <Users size={14} />
                                <span>Membri</span>
                            </button>
                        )}
                        {currentBando && canManageMembers && (
                            <button
                                type="button"
                                className="rag-bando-selector__btn rag-bando-selector__btn--danger"
                                onClick={() => {
                                    if (
                                        window.confirm(
                                            `Eliminare il bando "${currentBando.name}"?\n\n` +
                                                "Verranno eliminati anche tutti i suoi documenti e " +
                                                "le conversazioni associate.",
                                        )
                                    ) {
                                        deleteBando(currentBando.id);
                                    }
                                }}
                                aria-label="Elimina bando"
                                title="Elimina bando"
                            >
                                <Trash2 size={14} />
                            </button>
                        )}
                        <button
                            type="button"
                            className="rag-bando-selector__btn rag-bando-selector__btn--primary"
                            onClick={() => setShowCreate(true)}
                        >
                            <Plus size={14} />
                            <span>Nuovo bando</span>
                        </button>
                    </>
                ) : (
                    <form className="rag-bando-selector__create" onSubmit={handleCreate}>
                        <input
                            type="text"
                            className="rag-bando-selector__input"
                            placeholder="Nome bando"
                            value={newName}
                            onChange={(e) => setNewName(e.target.value)}
                            autoFocus
                            disabled={creating}
                        />
                        <button
                            type="submit"
                            className="rag-bando-selector__btn rag-bando-selector__btn--primary"
                            disabled={!newName.trim() || creating}
                        >
                            {creating ? "..." : "Crea"}
                        </button>
                        <button
                            type="button"
                            className="rag-bando-selector__btn"
                            aria-label="Annulla"
                            onClick={() => {
                                setShowCreate(false);
                                setNewName("");
                            }}
                        >
                            <X size={14} />
                        </button>
                    </form>
                )}
            </div>
            <BandoMembersModal
                open={showMembers}
                onClose={() => setShowMembers(false)}
            />
        </div>
    );
}
